import { call, put, takeLatest } from "redux-saga/effects";

import { apiUpdateArticles } from "helpers/api/articles";
import {
  UPDATE_ARTICLES,
  actUpdateArticlesFailed,
  actUpdateArticlesSuccess,
} from "store/actions/articles";
import { showToastError, showToastSuccess } from "utils";

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doUpdate(action) {
  try {
    const response = yield call(apiUpdateArticles, action?.payload);

    if (response?.data) {
      // Call callback action if provided
      yield put(actUpdateArticlesSuccess(response.data));

      if (action.onSuccess) {
        yield action.onSuccess();
      }
      showToastSuccess("messages.MSG-USP055");
    } else {
      throw new Error(
        response?.error?.reason
          ? `messages.${response?.error?.reason}`
          : response?.error?.message
      );
    }
  } catch (error) {
    yield put(actUpdateArticlesFailed());
    // Call callback action if provided
    showToastError(error?.message);
    if (action.onError) {
      yield action.onError(error);
    }
  }
}

export default function* watchUpdate() {
  yield takeLatest(UPDATE_ARTICLES, doUpdate);
}
